// import http from "../../http";
import { Unidade } from "./entities/Unidade";

const actions = {
  listar: async () => {
    try {
      // let resposta = await http.get(`apiv2/vendors/users`);
      let resposta = {
        data: {
          results: {
            data: [
              {
                id: 1,
                name: "Unidade 1",
                logo: "",
              },
              {
                id: 2,
                name: "Unidade 2",
                logo: "",
              },
              {
                id: 3,
                name: "Unidade 3",
                logo: "",
              },
            ],
          },
        },
      };
      let listaUnidades = [];
      resposta.data.results.data.forEach((unidadeDTO) => {
        listaUnidades.push(
          new Unidade({
            id: unidadeDTO.id,
            nome: unidadeDTO.name,
            logo: unidadeDTO.logo,
          })
        );
      });
      return {
        listaUnidades,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  },
};

export const unidade = {
  namespaced: true,
  actions,
};
